module.exports = __webpack_public_path__ + "835d0246a762f26d0642e617e6cae819.pdf";